import { Phone, Mail, Facebook, MapPin } from "lucide-react";
import { LOGO_URL, CONTACT, SERVICE_AREAS, SERVICES } from "@/data";

export const Footer = () => {
  return (
    <footer className="bg-[#0C1827] border-t border-[#1E324A]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-3">
              <img
                src={LOGO_URL}
                alt="Almaguin Yard Solutions logo"
                className="h-14 w-14 rounded-full object-cover ring-2 ring-[#F5A623]/70 bg-white"
              />
              <div className="leading-tight">
                <span className="font-display font-extrabold text-white tracking-tight text-sm uppercase block">
                  Almaguin Yard Solutions
                </span>
                <span className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#F5A623]">
                  Precision. Performance. Perfection.
                </span>
              </div>
            </div>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed">
              Fully insured excavation &amp; landscaping contractor serving the Almaguin Highlands
              and Muskoka region.
            </p>
            <a
              href={CONTACT.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-slate-300 hover:text-[#F5A623] transition-colors"
            >
              <Facebook size={17} /> Follow us on Facebook
            </a>
          </div>

          <div>
            <h3 className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#F5A623] mb-5">
              Contact
            </h3>
            <div className="space-y-4">
              <a
                href={CONTACT.phoneHref}
                data-testid="footer-phone-link"
                className="flex items-center gap-3 text-sm text-slate-300 hover:text-[#F5A623] transition-colors"
              >
                <Phone size={16} className="text-[#F5A623]" /> {CONTACT.phone}
              </a>
              <a
                href={CONTACT.emailHref}
                data-testid="footer-email-link"
                className="flex items-center gap-3 text-sm text-slate-300 hover:text-[#F5A623] transition-colors"
              >
                <Mail size={16} className="text-[#F5A623]" /> {CONTACT.email}
              </a>
              <div className="flex items-center gap-3 text-sm text-slate-300">
                <MapPin size={16} className="text-[#F5A623]" /> {CONTACT.region}
              </div>
            </div>
            <h3 className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#F5A623] mt-8 mb-4">
              Services
            </h3>
            <ul className="space-y-2">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <a href="#services" className="text-sm text-slate-400 hover:text-[#F5A623] transition-colors">
                    {s.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#F5A623] mb-5">
              Service Areas
            </h3>
            <div className="flex flex-wrap gap-2">
              {SERVICE_AREAS.map((area) => (
                <span
                  key={area}
                  className="text-xs font-medium text-slate-300 border border-[#1E324A] rounded-full px-3.5 py-1.5"
                >
                  {area}
                </span>
              ))}
            </div>
            <div className="mt-8 bg-[#142234] border border-[#1E324A] rounded-2xl p-5">
              <p className="text-sm text-slate-300 leading-relaxed">
                Need work outside these areas?{" "}
                <a href={CONTACT.phoneHref} className="text-[#F5A623] font-semibold">
                  Give us a call
                </a>{" "}
                — we travel for the right project.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#1E324A] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            &copy; {new Date().getFullYear()} Almaguin Yard Solutions. All rights reserved.
          </p>
          <p className="text-xs text-slate-500">Fully Insured Excavation &amp; Landscaping Contractor</p>
          <a href="/admin" data-testid="footer-admin-link" className="text-xs text-slate-600 hover:text-[#F5A623] transition-colors">
            Owner Login
          </a>
        </div>
      </div>
    </footer>
  );
};
